<script lang="ts">
	import type { PageComponentData } from '$lib/pages';
	import type { Page } from '$models/Page/Page';
	import { afterNavigate } from '$app/navigation';
	import MainLayout from '$components/Layout/MainLayout.svelte';
	import Ribbon from '$components/Layout/Ribbon.svelte';
	import { trackVirtualPageview } from '$lib/datalayer/datalayer';
	import { getFirstPanoramaPreloadLinks, getPageComponentData } from '$lib/pages';

	let { page }: { page: Page } = $props();

	let pageComponentResult = $derived(getPageComponentData(page));
	let panoramaPreloadLinks = $derived(getFirstPanoramaPreloadLinks(page));

	afterNavigate(() => {
		if (window && page.metadata.title) {
			trackVirtualPageview(window.location.href, page.metadata.title);
		}
	});
</script>

{#snippet renderPage(data: PageComponentData)}
	{#if data.layout !== null}
		<data.layout page={data.page} pageComponent={data.component} />
	{:else}
		<data.component page={data.page} />
	{/if}
{/snippet}

{#if page.layout.ribbon.length > 0}
	<Ribbon ribbon={page.layout.ribbon} />
{/if}

<MainLayout {page}>
	{#if pageComponentResult instanceof Promise}
		{#await pageComponentResult then pageComponentData}
			{#if pageComponentData}
				{@render renderPage(pageComponentData)}
			{/if}
		{/await}
	{:else if pageComponentResult}
		{@render renderPage(pageComponentResult)}
	{/if}
</MainLayout>

<svelte:head>
	{#if page.metadata.raw}
		{@html page.metadata.raw}
	{/if}

	{#each page.layout.meta.alternateLanguages as { language, link }}
		<link rel="alternate" hreflang={language} href={link} />
	{/each}

	{#each panoramaPreloadLinks as { href, media }}
		<link rel="preload" as="image" {href} {media} />
	{/each}
</svelte:head>
